import { Form, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSTextArea from 'components/CIMSTextArea'
import { useValidateWhitespaceProps } from 'components/CIMSTextArea/hooks/useValidateWhitespaceProps'

const ClosureFormItems: React.FC = () => {
  return (
    <>
      <Form.Item hidden name="action" initialValue="close">
        <Input />
      </Form.Item>
      <CIMSFormItem
        name="closureNotes"
        help={HelpMessage.Issues.IssueTracker.ClosureNotes}
        {...useValidateWhitespaceProps({
          label: 'Closure Notes',
          required: true,
        })}
      >
        <CIMSTextArea maxLength={2000} />
      </CIMSFormItem>
    </>
  )
}

export default ClosureFormItems
